export const DEFAULT_INVENTORY_UOM = "YD";
export const DEFAULT_INVENTORY_UOM_3PL = "EA";
export const DEFAULT_CURRENCY_CODE = "USD";
export const NEW_ENTRY = "NEW";
export const DEFAULT_WAREHOUSE = "WH1";
export const DEFAULT_WEIGHT_UOM_3PL = "LBS";
// 1 -> countable 2 --> length 3 --> Weight
export const COUNTABLE_UOM_TYPE = 1;
export const LENGTH_UOM_TYPE = 2;
export const WEIGHT_UOM_TYPE = 3;
export const DEMO_VALUE = "N/A";
export const DEFAULT_CUSTOMER_DELIVERY_CODE = "D";
export const DEFAULT_VENDOR = "LOGISTICS";
export const DEFAULT_CODIFICATION_FILEDS_CODE_3PL = "G";
export const DEFAULT_CODIFICATION_FILEDS_DESC_3PL = "general";
export const NOT_APPLICABLE_ENTRY = "$N/A$";

/* Payment Type */
export const CHECK_PAYMENT_TYPE = "CHECK";

/* target Websites */
export const TARGET_WEBSITE_SHOPIFY = "SHOPIFY";
export const TARGET_WEBSITE_WAYFAIR = "WAYFAIR";

/* image Part */

export const MAIN_IMAGE_PART = "Main";
export const WEB_IMAGE_PART = "Web";
export const FRONT_IMAGE_PART = "Front";
export const BACK_IMAGE_PART = "Back";

export const DOCUMENT_CHANGED = "$$$CHANGED$$$";
export const DEFAULT_TEXCO_WAREHOUSE = "Washington Whse";
